import template from './employeeSearch.html';
import controller from './employeeSearch.controller';
import './employeeSearch.scss';

let employeeSearchComponent = {
  restrict: 'E',
  bindings: {
    onSelectEmployee: '&',
    onSearch: '&?',
    minLengthSearch: '<?',
    placeholderText: '<?',
    fixedSelection: '<?',
    showAlertCard: '<',
    isMobileApp: '<',
    onCleanSearch: '&?',
    enableAlert:'<',
    reportSearchState: '&?',
  },
  template,
  controller,
};

export default employeeSearchComponent;



// WEBPACK FOOTER //
// ./client/app/components/employeeSearch/employeeSearch.component.js